export default "__VITE_PUBLIC_ASSET__af655215__"